import axios from '@/utils/request.js'

export const getCylinderInfoMessByCode = (qrCode) => {
  return axios.get(`/goods/gas/cylinder/getCylinderInfoMessByCode/${qrCode}`)
}
export const geGroupInfoMessByCode = (qrCode) => {
  return axios.get(`/goods/gas/cylinder/geGroupInfoMessByCode/${qrCode}`)
}

export const getUserNewsList = (params) => {
  return axios.post('/goods/gas/news/getUserNewsList', params)
}

export const report = (params) => {
  return axios.post('/goods/gas/report/add', params)
}

export const getDetail = (id) => {
  return axios.get(`/goods//gas/news/getDetail/${id}`)
}
